module.exports = __webpack_public_path__ + "img/UL_Logo.47259e5f.png";